import { apiClient } from "@/shared/apiClient";
import { z } from "zod";

const presignRequestSchema = z.object({
  fileName: z.string(),
  mimeType: z.string(),
  taskId: z.number().nullable().optional(),
});

const presignResponseSchema = z.object({
  storageKey: z.string(),
  presignedUrl: z.string(),
  publicUrl: z.string().optional(), // Public URL if provided by backend
});

export type PresignRequest = z.infer<typeof presignRequestSchema>;
export type PresignResponse = z.infer<typeof presignResponseSchema>;

export const uploadsApi = {
  /**
   * Get a presigned URL for uploading a file to Cloudflare R2
   * @param fileName - The name of the file
   * @param mimeType - The MIME type of the file (e.g., 'image/jpeg')
   * @param taskId - Optional task ID if the upload is associated with a task
   * @returns Promise with storageKey and presignedUrl
   */
  async getPresignedUrl(
    fileName: string,
    mimeType: string,
    taskId?: number | null
  ): Promise<PresignResponse> {
    try {
      const requestData = {
        fileName,
        mimeType,
        ...(taskId !== undefined && taskId !== null && { taskId }),
      };

      presignRequestSchema.parse(requestData);

      const response = await apiClient.post(`/api/employee/uploads/presign`, requestData);

      // Handle nested response structure: { success: true, data: { storageKey, presignedUrl } }
      const responseData = response.data || response;
      
      return apiClient.validateResponse(responseData, presignResponseSchema);
    } catch (error) {
      console.error("Error getting presigned URL:", error);
      throw error;
    }
  },
};

